import MarqueeHeading from "./common/MarqueeHeading";

const Thankyou = () => (
  <div className="pt-24 px-6 pb-12 md:px-8 md:pb-80 xl:px-0 xl:pt-0">
    <div className="relative md:top-56">
      <h2 className="font-bold text-5xl md:text-8xl text-white text-start md:text-center mb-4">
        <span className="font-gilroy">Thank You!</span>
      </h2>
      <div className="flex justify-center">
        <p className="text-white font-light md:font-normal text-lg md:text-2xl w-full md:w-1/2 text-justify md:text-center">
          <span className="font-gilroy">
            We have converted the wireframes into final screens, and tried to
            keep the UI simple and intuitive with a user centered approach. The
            app’s design has simple sign in & verification screens and booking
            process.
          </span>
        </p>
      </div>
    </div>
    <div className="hidden md:block">
      <MarqueeHeading marqueeTitle={"THANK YOU!"} />
    </div>
  </div>
);
export default Thankyou;
